import { z } from "zod";

import { SaleTypeForTerm } from "@/lib/gql/__generated__/graphql";
import { DiscountMultiInputSchema } from "@/lib/zod/__generated__/validation-schema";

import { chillnnDateZodSchema } from "@/components/features/_shared/validation-schema/validation-schema";

import * as DiscountItemShared from "../../../../_shared";

/**
 * 複合ディスカウントの設定用のバリデーションスキーマ
 */
export const DiscountMultiInputZodSchema = DiscountMultiInputSchema.extend({
	saleStart: chillnnDateZodSchema.nullish().or(z.literal("")),
	saleEnd: chillnnDateZodSchema.nullish().or(z.literal("")),

	stayableStart: chillnnDateZodSchema.nullish().or(z.literal("")),
	stayableEnd: chillnnDateZodSchema.nullish().or(z.literal("")),

})
	.and(DiscountItemShared.Model.ValidationSchema.CommonDiscountInputZodSchema.omit({ resourceLowestPrice: true }))
	// 公開する期間（設定する場合は開始日・終了日をセットで設定する）
	.refine(
		({ saleStart, saleEnd, saleTypeForTerm }) => {
			if (saleTypeForTerm === SaleTypeForTerm.Limited) {
				return !!saleStart === !!saleEnd;
			}

			return true;
		},
		{
			message: "公開する期間は開始日と終了日の両方を設定してください",
			path: ["saleEnd"],
		},
	)
	// 公開する期間
	.refine(
		({ saleStart, saleEnd, saleTypeForTerm }) => {
			if (saleTypeForTerm === SaleTypeForTerm.Limited) {
				if (!!saleStart && !!saleEnd) {
					return saleStart <= saleEnd;
				}

				return true;
			}

			return true;
		},
		{
			message: "終了日が開始日以降になるように設定してください",
			path: ["saleEnd"],
		},
	)
	// 滞在可能な期間
	.refine(
		({ stayableStart, stayableEnd, saleTypeForTerm }) => {
			if (saleTypeForTerm === SaleTypeForTerm.Limited) {
				if (!!stayableStart && !!stayableEnd) {
					return stayableStart <= stayableEnd;
				}

				// 片側だけ設定して保存するとサーバー側の適用判定で割引が一切適用されなくなるため、両方必須にする
				return false;
			}

			return true;
		},
		{
			message: "滞在可能な期間を設定してください",
			path: ["stayableEnd"],
		},
	);

export type DiscountMultiInputZodSchemaType = z.infer<typeof DiscountMultiInputZodSchema>;
